import React from 'react'
import { Typography } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import DailyProgressBar from './DailyProgressBar'
import Questionnaire from './Questionnaire/Questionnaire'
import FilterBar from './FilterBar'
import './daily-logbook.scss'

function DailyLogbookEvents(props) {
  return (
    <div className="module daily-logbook-module">
      <div className="module-head">
        <Typography variant="h5" className="module-title">
          {props.currentApp.name}
        </Typography>
        <div className="module-filter">
          <FilterBar hideButton />
        </div>
      </div>
      <div className="module-content">
        <DailyProgressBar />
        <Questionnaire />
      </div>
    </div>
  )
}

export default injectIntl(DailyLogbookEvents)
